/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = '£{{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function updatePrices(currentVariant) {
  productData = JSON.parse($('[data-product-json]').html());
  allVariants = productData.product.variants;
  newVariant = currentVariant;
  option_positions = ['option1', 'option2', 'option3'];
  $('.Popover__ValueList[data-option-name]').each(function (index, value) {
    option_name = $(this).attr('data-option-name');
    option_position = $(this).attr('data-option-position');
    other_option_positions = option_positions.filter(
      (position) => position !== option_position
    );
    option_values = $(this).find('.Popover__Value');

    correct_variants = [];
    $.each(other_option_positions, (i, option_position) => {
      if (newVariant[option_position]) {
        other_variants_with_option = allVariants.filter(
          (variant) => variant[option_position] === newVariant[option_position]
        );
        correct_variants = correct_variants.concat(other_variants_with_option);
      }
    });

    if (correct_variants.length == 0) {
      correct_variants = allVariants;
    }

    $(option_values).each(function () {
      option_value = $(this).attr('data-value');
      thisVariant = correct_variants.filter(
        (variant) => variant[option_position] == option_value
      )[0];
      //$(this).find(".variant-dynamic-price").text(Shopify.formatMoney(thisVariant.price))
      price = Shopify.formatMoney(thisVariant.price);
      newText = $(this).text().split('£')[0] + price;
      $(this).text(newText);
    });
  });
}

let newVariant;
productData = JSON.parse($('[data-product-json]').html());
selectedVariant = productData.product.variants.filter(
  (variant) => variant.id == productData.selected_variant_id
)[0];
updatePrices(selectedVariant);
document.addEventListener('variant:changed', function (event) {
  updatePrices(event.detail.variant);
});
